import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import app from '../../package.json';
import { store } from 'redux/store';
import { sanitizeHostname } from './hostname';

const hostname = sanitizeHostname(window.location.hostname);

export const BugTracker: any = Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || '',
  plugins: [new BugsnagPluginReact()],
  appVersion: app.version,
  releaseStage: process.env.NODE_ENV,
  // Keep the React error boundary while Bugsnag reporting is disabled.
  enabledReleaseStages: [],
  autoTrackSessions: false,
  onError: (e) =>
    e.addMetadata('account', {
      type: hostname,
      name: store.getState().user.user.Title,
      email: store.getState().user.user.UserInstanceEmail,
      id: store.getState().user.user.Id
    })
});
